<template>
  <Modal title="导入题库" style="top: 30%;" v-model="uploatModal" footer-hide>
    <Upload style="margin-left: 10px;" :action="action" type="drag" :headers="headers" :on-success="importSuccess">
      <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
      <p>选择或拖动文件进行导入</p>
    </Upload>
  </Modal>
  <Modal :title="id ? '编辑题目' : '新增题目'" :styles="{ top: '20px' }" v-model="modal" footer-hide>
    <SubjectModal :id="id" @save="save" @close="close"></SubjectModal>
  </Modal>
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: end; padding-bottom: 15px;">
    <Button @click="add" type="info">
      <Icon type="ios-add"></Icon> 新增题目
    </Button>
    <Button @click="getDocumentt" type="primary" style="margin-left: 10px;">
      <Icon type="ios-document"></Icon> 模板下载
    </Button>
    <Button @click="() => { this.uploatModal = !this.uploatModal }" type="primary" style="margin-left: 10px;">
      <Icon type="ios-cloud-upload"></Icon> 导入题库
    </Button>
    <Button @click="removeSelection" type="error" style="margin-left: 10px;">
      <Icon type="ios-trash"></Icon> 删除选中题目
    </Button>
  </div>
  <Table :loading="loading" border ref="table" ex :columns="columns" :data="data" @on-selection-change="selection">
    <template #tools="{ row }">
      <Button size="small" type="info" @click="edit(row)">编辑</Button>
      <Button size="small" type="error" style="margin-left: 10px;" @click="removeFunction(row)">删除</Button>
    </template>
  </Table>
  <Space v-margin="10" style="width: 100%; 
  display: flex; align-items: center; justify-content: center;">
    <Page v-model="page.current" :total="page.total" :page-size="page.size" show-total show-elevator show-sizer
      :page-size-opts="[10, 20, 50, 100]" @on-change="changePage" @on-page-size-change="changePageSize" />
  </Space>
</template>
<script>
import { infoPage, remove } from "@/api/subject/index";
import SubjectModal from "@/views/subject/modal.vue"
import Setting from '@/setting';
import store from '@/store';

export default {
  components: {
    SubjectModal
  },
  data() {
    return {
      selectionRows: [],
      uploatModal: false,
      action: Setting.baseUrl + '/subject/import',
      headers: {
        'Authorization': 'Bearer ' + store.getters.getToken
      },
      id: null,
      modal: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '题目',
          key: 'subject',
          align: 'center'
        },
        {
          title: '解析',
          key: 'answer',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'tools',
          width: 150,
        }
      ],
      data: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      loading: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getDocumentt(){
      const filename = '题库导入模板.xlsx';
      const url = '/temp/题库导入模板.xlsx'; // 文件路径，根据实际情况进行修改
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    importSuccess(e) {
      this.uploatModal = false
      this.$Message.success("题库导入成功！")
      this.getData()
    },
    removeSelection() {
      if (this.selectionRows.length == 0) return;
      this.$Modal.confirm({
        title: '温馨提示',
        content: '确认要删除选中的题目吗？',
        onOk: () => {
          remove(this.selectionRows).then(res => {
            if (res.code == 0) {
              this.$Message.success("题目删除成功！");
              this.getData()
            }
          })
        }
      });
    },
    removeFunction(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '确认要删除该题目吗？',
        onOk: () => {
          remove([row]).then(res => {
            if (res.code == 0) {
              this.$Message.success("题目删除成功！");
              this.getData()
            }
          })
        }
      });
    },
    selection(rows) {
      this.selectionRows = rows
    },
    exportData() {

    },
    getData() {
      this.loading = true
      infoPage({
        size: this.page.size,
        current: this.page.current
      }).then(res => {
        this.page.total = res.data.total
        this.data = res.data.records
        this.loading = false
      })
    },
    changePage() {
      this.getData()
    },
    changePageSize(res) {
      this.page.size = res
      this.getData()
    },
    add() {
      setTimeout(() => {
        this.id = null
        this.modal = true
      }, 100);
    },
    save() {
      this.modal = false
      this.getData()
    },
    close() {
      this.modal = false
    },
    edit(row) {
      setTimeout(() => {
        this.id = row.id
        this.modal = true
      }, 100);
    }
  }
}
</script>
<style></style>
@/api/subject/index